import { Component, computed, effect, inject, Injector, input, OnInit, runInInjectionContext } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { isEqual } from 'lodash';
import { startWith } from 'rxjs';
import { EWidgetRequest, EWidgetRequestCategory } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';
import { FormFieldDropdownStore } from './form-field-dropdown.store';

@Component({
  imports: [MatDropdown],
  providers: [FormFieldDropdownStore],
  selector: 'form-field-dropdown',
  styleUrl: './form-field-dropdown.component.scss',
  templateUrl: './form-field-dropdown.component.html',
})
export class FormFieldDropdownComponent implements OnInit {
  public readonly store = inject(FormFieldDropdownStore);
  public readonly injector = inject(Injector);
  public readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<string>[]>>();
  public readonly isFormSubmitted = input.required<boolean>();
  public readonly widgetRequestFormControl = input.required<FormControl<IDropdownOption<number | EWidgetRequest>[]>>();
  public readonly widgetRequestCategoryFormControl =
    input.required<FormControl<IDropdownOption<EWidgetRequestCategory>[]>>();

  public readonly dropdownSettings: IDropdownSettings = {
    enableSearchFilter: true,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.formFieldDropdown.label'),
  };

  public readonly dropdownOptions = computed(
    () => {
      return this.store.formFields().map((formField) => ({
        id: formField.key,
        name: formField.label,
      }));
    },
    { equal: isEqual },
  );

  public ngOnInit(): void {
    this.widgetRequestFormControl()
      .valueChanges.pipe(startWith(this.widgetRequestFormControl().value))
      .subscribe((value) => {
        const id = value[0]?.id;

        if (
          typeof id === 'number' &&
          this.widgetRequestCategoryFormControl().value[0]?.id === EWidgetRequestCategory.formSubmissions
        ) {
          this.store.loadFormFields(id);
        }
      });

    runInInjectionContext(this.injector, () => {
      effect(() => {
        const dropdownOptions = this.dropdownOptions();
        const [selectedOption] = this.formControl().value;

        if (
          selectedOption &&
          selectedOption.name !== '...' &&
          !dropdownOptions.some(({ id, name }) => id === selectedOption.id && name === selectedOption.name)
        ) {
          this.formControl().reset([]);
        }
      });
    });
  }
}
